import { GiveawayType } from "@/store/types"
import { defineComponent, PropType } from "vue"
import Button from "@/components/uikit/Button.vue"
import { GiveawayStatus } from "@/services/enums"
export default defineComponent({
  components: { Button },
  props: {
    giveaway: {
      type: Object as PropType<GiveawayType>,
      required: true,
    },
  },
  data() {
    return {
      duration: {
        hours: 0,
        min: 0,
        sec: 0,
      },
    }
  },
  computed: {
    buttonText() {
      return this.giveaway.is_participant ? "Participating" : "Participate"
    },
    isFinished() {
      return this.giveaway.status === GiveawayStatus.FINISHED
    },
    endDate() {
      const start = new Date(this.giveaway.start_date)
      return new Date(
        start.getTime() +
          this.giveaway.duration * this.giveaway.cycle_count * 60 * 1000
      )
      // return new Date(this.giveaway.start_date)
    },
  },
})
